import {generateOddsButton} from '#core/application/modules/tiles/odds-button/index.js';

export function outrightCardsFactory(PALETTE) {
    return {
        OutrightEventCard: {
            showBackgroundSportImage: !PALETTE.PARENT.CARD_WATERMARK_ICON_HIDDEN,
            eventCardBase: {
                container: {
                    style: {
                        justifyContent: 'space-between',
                    },
                },
                title: {
                    style: PALETTE.CARD_EVENT_NAME_TEXT,
                },
            },
            topContainer: {
                style: {
                    justifyContent: 'space-between',
                },
            },
            headerContainer: {
                style: {
                    flexGrow: 0,
                    flexShrink: 0,
                    flexBasis: 'auto',
                    justifyContent: 'initial', // fixing wrong mojito style
                },
            },
            marketHeader: {
                style: {
                    flexGrow: 0,
                    flexShrink: 0,
                    flexBasis: 'auto',
                },
            },
            marketNameLabel: {
                style: PALETTE.CARD_MARKET_NAME_TEXT,
            },
            showAllLabel: {
                container: {
                    flexShrink: 0,
                },
                style: PALETTE.CARD_SHOW_ALL_LINK.SECONDARY_LINK_TEXT,
            },
            showAllIcon: {
                style: {
                    fill: PALETTE.CARD_SHOW_ALL_LINK.SECONDARY_LINK_ICON_COLOR,
                },
            },
            sportIcon: {
                icon: {
                    style: {
                        fill: PALETTE.CARD_SPORT_ICON_COLOR,
                        minWidth: 12,
                    },
                },
            },
            selectionButton: generateOddsButton(PALETTE.EVENT_CARDS_ODDS_BUTTON),
        },
    };
}
